module.exports = __webpack_public_path__ + "static/image/sign/kimbongjin.png?d7deb768";